const FEATURE_FLAGS_STORAGE_KEY = '@hapvida/feature-flags';
const FEATURE_FLAG_CACHE_TIME = 1000 * 60 * 20;

export {FEATURE_FLAGS_STORAGE_KEY, FEATURE_FLAG_CACHE_TIME};
